import { type ReactNode, useState } from 'react'

import { type IconElement, IconUser, MenuListItem } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { ChatMenuStyled } from './styles/ChatMenuStyled'

/** A conversation held outside the internal comment thread. */
export interface IChatMenuExternalThread {
  label: string
  icon: IconElement
  onOpen: () => void
  /** When set, the item is disabled and the hint explains why. */
  disabledHint?: string
}

export interface IChatMenuProps {
  /** Rendered in place of the menu once the internal thread is chosen. */
  colleaguesThread: ReactNode
  externalThread: IChatMenuExternalThread
}

/**
 * ChatMenu chooses between an object's internal colleagues thread and one
 * external conversation described by props.
 */
export const ChatMenu = ({
  colleaguesThread,
  externalThread,
}: IChatMenuProps) => {
  const intl = useProcurifyIntl()
  const [mode, setMode] = useState<'menu' | 'colleagues'>('menu')

  if (mode === 'colleagues') {
    return <>{colleaguesThread}</>
  }

  return (
    <ChatMenuStyled
      role='group'
      aria-label={intl.formatMessage(messages.menuAriaLabel)}
    >
      <MenuListItem
        icon={<IconUser />}
        text={intl.formatMessage(messages.messageColleagues)}
        onClick={() => setMode('colleagues')}
      />
      <MenuListItem
        icon={externalThread.icon}
        text={externalThread.label}
        disabled={!!externalThread.disabledHint}
        tooltip={externalThread.disabledHint}
        onClick={() => {
          if (externalThread.disabledHint) return

          externalThread.onOpen()
        }}
      />
    </ChatMenuStyled>
  )
}
